module.exports = __webpack_public_path__ + "static/media/mimox.2d2efb0c.png";